export default {
  首页: "Domů",
  资产: "Aktiva",
  币币: "Spot",
  快捷买币: "Rychlý nákup kryptoměn",
  "支持多种方式购买，购买更简单":
    "Nakupujte snadno pomocí více platebních metod",
  语言设置: "Nastavení jazyka",
  确认恢复: "Potvrdit obnovení",
  "输入邮箱，方便我们联系您":
    "Zadejte svůj e-mail, abychom vás mohli kontaktovat",
  划转: "Převést",
  行情: "Trh",
  "24H成交": "Objem 24h",
  累计收益: "Celkový výnos",
  充值时间: "Datum vkladu",
  到期时间: "Datum vypršení",
  数量: "Množství",
  操作: "Akce",
  资产信息: "Informace o aktivech",
  复制地址: "Kopírovat adresu",
  链名称: "Název řetězce",
  充值地址: "Adresa pro vklad",
  收款地址: "Přijímací adresa",
  账单: "Faktura",
  提现金额: "Částka k výběru",
  接收地址: "Přijímací adresa",
  交易密码: "Obchodní heslo",
  提现全部: "Vybrat vše",
  保存图片: "Uložit obrázek",
  输入您的交易密码: "Zadejte své obchodní heslo",
  确定: "Potvrdit",
  地址: "Adresa",
  注册时间: "Datum registrace",
  取消: "Zrušit",
  是否划转: "Převést?",
  登录: "Přihlásit se",
  我的地址: "Moje adresy",
  登录密码和交易密码: "Přihlašovací heslo a obchodní heslo",
  注册: "Registrovat",
  密码: "Heslo",
  设置密码: "Nastavit heslo",
  重复密码: "Opakovat heslo",
  新密码: "Nové heslo",
  确认新密码: "Potvrdit nové heslo",
  充值: "Vložit",
  充值货币: "Vložit měnu",
  合约账户充值: "Vložit na účet futures",
  账户充值: "Vložit na účet",
  其他: "Jiné",
  我的邀请码: "Můj pozvánkový kód",
  提现: "Vybrat",
  客服: "Zákaznická podpora",
  持有详情: "Podrobnosti držení",
  请输入内容: "Zadejte obsah",
  邀请好友来领取奖励: "Pozvěte přátele a získejte odměny",
  复制链接: "Kopírovat odkaz",
  重复设置新的密码: "Opakovat nové heslo",
  保存: "Uložit",
  我的: "Můj účet",
  "邮箱/手机号": "E-mail/Telefonní číslo",
  备注: "Poznámka",
  地址管理: "Správa adres",
  我的团队: "Můj tým",
  联系我们: "Kontaktujte nás",
  竭诚为您服务: "Jsme vám k dispozici",
  提取收益: "Vybrat výnos",
  带给我的收益: "Generovaný výnos",
  添加: "Přidat",
  名称: "Název",
  添加地址: "Přidat adresu",
  修改地址: "Změnit adresu",
  可提现: "Výběr možný",
  安全中心: "Bezpečnostní centrum",
  收益划转: "Převést výnos",
  通知中心: "Oznámení",
  "累计收益:": "Celkový výnos:",
  注册用户: "Registrovaní uživatelé",
  奖励规则: "Pravidla odměn",
  帮助反馈: "Nápověda a zpětná vazba",
  邀请好友: "Pozvat přátele",
  恢复身份: "Obnovit identitu",
  选择语言: "Zvolit jazyk",
  设置新的密码: "Nastavit nové heslo",
  暂无活动: "Žádné aktivní aktivity",
  "月增长量(+)": "Měsíční růst (+)",
  可提取: "Výběr možný",
  反馈类型: "Typ zpětné vazby",
  赠送: "Dárek",
  已经复制: "Zkopírováno",
  保存成功: "Uloženo",
  划转成功: "Převod úspěšný",
  过期: "Vypršelo",
  提交成功: "Odesláno",
  "服务器繁忙，稍后在试": "Server je zaneprázdněn, zkuste to později",
  全部: "Vše",
  一级: "Úroveň 1",
  二级: "Úroveň 2",
  三级: "Úroveň 3",
  级: "Úroveň",
  删除成功: "Smazáno",
  选择地址: "Vybrat adresu",
  不再提醒: "Znovu nezobrazovat",
  "最小充值金额：": "Minimální částka vkladu:",
  选择币种: "Vybrat kryptoměnu",
  输入投资金额: "Zadejte částku investice",
  输入账户密码: "Zadejte heslo účtu",
  投资: "Investovat",
  订单编号: "Číslo objednávky",
  投资周期: "Investiční období",
  投资资金: "Investovaná částka",
  投资时间: "Čas investice",
  状态: "Stav",
  投资中: "Aktivní",
  已到期: "Vypršelo",
  暂无数据: "Žádná data",
  转入: "Převést na",
  邮箱: "E-mail",
  请输入邮箱: "Zadejte e-mail",
  请输入格式正确的邮箱: "Zadejte platný e-mail",
  请输入验证码: "Zadejte ověřovací kód",
  获取验证码: "Získat ověřovací kód",
  请输入邀请码: "Zadejte pozvánkový kód",
  今天: "Dnes",
  昨天: "Včera",
  最近七天: "Posledních 7 dní",
  邀请: "Pozvat",
  购买数量: "Množství k nákupu",
  产品详情: "Podrobnosti produktu",
  币种: "Kryptoměna",
  利息币种: "Měna výnosu",
  理财类型: "Typ finančního produktu",
  产品费率: "Poplatky produktu",
  进行中: "Aktivní",
  每天: "Denně",
  请输入搜索关键词: "Zadejte klíčové slovo",
  通知: "Oznámení",
  查看更多: "Zobrazit více",
  理财宝: "Finanční produkty",
  周期: "Doba trvání",
  年利率: "Roční úroková sazba (APY)",
  更多产品: "Více produktů",
  灵活存取: "Flexibilní spoření",
  稳定收益: "Stabilní výnos",
  合约指南: "Průvodce futures",
  资金划转出: "Odchozí převod",
  矿池收益: "Těžební odměna",
  提现手续费: "Poplatek za výběr",
  冻结资金: "Zmrazené prostředky",
  解冻资金: "Uvolnění zmrazených prostředků",
  闪兑支出: "Výdaj za rychlou směnu",
  闪兑收入: "Příjem z rychlé směny",
  闪兑手续费: "Poplatek za rychlou směnu",
  合约支出: "Výdaj za futures",
  合约收入: "Příjem z futures",
  输入的金额不可大于可用金额: "Částka nesmí přesáhnout dostupnou částku",
  全部兑换成功: "Úplná směna úspěšná",
  返回: "Zpět",
  查看历史: "Zobrazit historii",
  闪兑历史: "Historie rychlé směny",
  支付: "Zaplatit",
  获取: "Získat",
  时间: "Čas",
  手续费: "Poplatek za transakci",
  折扣: "Sleva",
  价格: "Cena",
  逐仓: "Izolovaná marže",
  全仓: "Křížová marže",
  市价委托: "Tržní příkaz",
  限价委托: "Limitní příkaz",
  请输入本金: "Zadejte jistinu",
  请输入价格: "Zadejte cenu",
  "可做空/做多": "Možnost short/long",
  设置止盈止损: "Nastavit take-profit/stop-loss",
  止盈价: "Cena take-profit",
  止损价: "Cena stop-loss",
  成本: "Pořizovací cena",
  做多: "Long",
  做空: "Short",
  仓位信息: "Informace o pozici",
  一键平仓: "Uzavřít pozici (jedním kliknutím)",
  永续: "Perpetual",
  浮动盈亏: "Nerealizovaný zisk/ztráta",
  平仓: "Uzavřít pozici",
  反向开仓: "Otevřít opačnou pozici",
  一键撤销: "Zrušit vše (jedním kliknutím)",
  倍杠杆: "násobná páka",
  执行价格: "Realizační cena",
  委托数量: "Množství příkazu",
  保证金: "Marže",
  成交价: "Realizační cena",
  创建时间: "Čas vytvoření",
  撤销: "Zrušit",
  合约市场: "Trh futures",
  交易方向: "Směr obchodu",
  委托价格: "Cena příkazu",
  委托金额: "Částka příkazu",
  资金费率: "Sazba financování",
  "多方和空方交易者支付的定期费用，每8小时结算一次。":
    "Pravidelný poplatek placený dlouhými a krátkými pozicemi, vypořádávaný každých 8 hodin.",
  "资金费率为正，多方向空方支付资金费用。":
    "Při kladné sazbě financování platí dlouhé pozice krátkým pozicím.",
  "资金费率为负，空方向多方支付资金费用。":
    "Při záporné sazbě financování platí krátké pozice dlouhým pozicím.",
  "确定反向开仓吗？反向开仓将以当期相反 的仓位进行买入":
    "Opravdu chcete otevřít opačnou pozici? Tímto nakoupíte opačný směr vaší aktuální pozice.",
  "仓位止盈/止损": "Take-profit/Stop-loss pro pozici",
  合约名称: "Futures kontrakt",
  开仓价格: "Otevírací cena",
  指数价格: "Indexová cena",
  止盈设置: "Nastavení take-profit",
  请输入止盈价: "Zadejte cenu take-profit",
  "当指数价格触达*时，将会触发委托平仓":
    "Když indexová cena dosáhne *, spustí se příkaz k uzavření.",
  预计盈亏: "Očekávaný zisk/ztráta",
  当前仓位: "Aktuální pozice",
  平仓金额: "Částka uzavření",
  仓位模式: "Režim pozice",
  全仓模式: "Režim křížové marže",
  "合约账户中的所有可用资金视作为可用保证金， 当仓位亏损超过了账户余额才会爆仓强平，并将损失所有 保证金和仓位，请注意":
    "V režimu křížové marže jsou všechny dostupné prostředky na vašem účtu futures používány jako marže. Likvidace nastane, když ztráta překročí váš celkový zůstatek, což má za následek ztrátu celé vaší marže a pozice.",
  逐仓模式: "Režim izolované marže",
  "会使合约账户中的一定数量保证金被分配到仓位上。如果保证金亏损低于维持保证金的水平，仓位被强平。在逐仓模式下，您可以为这个仓位增加和减少保证金。":
    "Určité množství marže je přiřazeno k pozici. Pokud ztráta marže klesne pod úroveň udržovací marže, pozice je zlikvidována. V režimu izolované marže můžete pro tuto pozici zvyšovat nebo snižovat marži.",
  "是否撤销？": "Zrušit příkaz?",
  "是否一键撤销？": "Zrušit všechny příkazy?",
  "是否一键平仓？": "Uzavřít všechny pozice?",
  持仓保证金: "Marže aktuální pozice",
  风险率: "Míra rizika",
  未实现盈亏: "Nerealizovaný zisk/ztráta",
  可用保证金: "Dostupná marže",
  净值: "Čistá hodnota",
  账户余额: "Zůstatek účtu",
  合约计算器: "Kalkulačka futures",
  交易记录: "Historie transakcí",
  "*倍杠杆": "*násobná páka",
  "平仓盈亏：": "Realizovaný zisk/ztráta:",
  时间筛选: "Filtr času",
  仓位类型: "Typ pozice",
  订单状态: "Stav objednávky",
  订单类型: "Typ příkazu",
  平仓价格: "Uzavírací cena",
  持仓数量: "Množství pozice",
  "手续费(%)": "Poplatek za transakci (%)",
  平仓时间: "Čas uzavření",
  平仓类型: "Typ uzavření",
  手动平仓: "Ruční uzavření",
  强制平仓: "Nucená likvidace",
  近1天: "Poslední den",
  近7天: "Posledních 7 dní",
  近30天: "Posledních 30 dní",
  近180天: "Posledních 180 dní",
  持仓: "Otevřená pozice",
  已取消: "Zrušeno",
  分时: "Intradenní",
  "24H额(USDT)": "24h objem (USDT)",
  "24H低": "24h minimum",
  "24H量(BTC)": "24h objem (BTC)",
  "24H高": "24h maximum",
  "10秒": "10 sekund",
  "30秒": "30 sekund",
  "1分": "1 minuta",
  "3分": "3 minuty",
  "5分": "5 minut",
  "30分": "30 minut",
  "1小时": "1 hodina",
  "4小时": "4 hodiny",
  "8小时": "8 hodin",
  "1天": "1 den",
  "1周": "1 týden",
  "1月": "1 měsíc",
  单向持仓: "Jednosměrná pozice",
  杠杆: "Páka",
  仓位: "Pozice",
  计算结果: "Výsledek",
  盈亏: "Zisk/Ztráta",
  收益率: "Výnos",
  计算结果仅供参考: "Výsledek je orientační",
  成交后仓位大小: "Velikost pozice po provedení",
  "计算结果仅供参考,实际结果可能因费率差异":
    "Výsledek je orientační, skutečné výsledky se mohou lišit kvůli poplatkům.",
  目标价格: "Cílová cena",
  开始计算: "Vypočítat",
  强平价格: "Liquidační cena",
  "充值前，请认真核对充值的链名称，充值错误无法找回资产*最小充值金额为*；少于此金额平台将无法确认到账，请不要向此地址充值*之外的资产，否则将无法找回资产，请不要直接提现众筹或者ICO地址，平台不会代理币的发放。":
    "Před vkladem pečlivě zkontrolujte název řetězce. Chybné vklady nelze vrátit. Minimální částka vkladu je *. Vklady pod tuto částku nebudou zpracovány. Neodesílejte jiná aktiva na tuto adresu. Nepoužívejte ICO nebo crowdfundingové adresy pro výběry.",
  "最小输入*": "Minimum {0}",
  "最小提币数量为*，提币手续费将从你的提款金额中扣除。提币前请确认核对收款地址，不要将*提现至*以外的地址，否则无法找回资产。请不要直接提现众筹或者ICO地址，平台不会处理代币的发放。":
    "Minimální množství výběru je *. Poplatky za výběr budou odečteny z částky výběru. Pečlivě zkontrolujte adresu příjemce. Neodesílejte * na adresy mimo *. Nepoužívejte ICO nebo crowdfundingové adresy.",
  退出登录: "Odhlásit se",
  加仓: "Zvýšit pozici",
  新增仓位: "Nová pozice",
  输入加仓金额: "Zadejte částku pro zvýšení pozice",
  "当前可用:": "Aktuálně dostupné:",
  资产账单: "Faktura aktiv",
  保存二维码: "Uložit QR kód",
  温馨提示: "Poznámka",
  "请注意：您当前使用的网络": "Poznámka: Aktuálně používáte síť",
  输入提现地址: "Zadejte adresu pro výběr",
  "可用金额：": "Dostupná částka:",
  输入资产密码: "Zadejte heslo aktiv",
  可用手续费: "Dostupný poplatek",
  "折扣%": "Sleva %",
  实扣手续费: "Skutečně účtovaný poplatek",
  实际到账: "Skutečně přijatá částka",
  未设置资产密码: "Heslo aktiv není nastaveno",
  "为了您的资产安全，请设置资产密码后再来提现。":
    "Pro vaši bezpečnost nastavte heslo aktiv před provedením výběru.",
  热榜: "Populární",
  涨幅榜: "Největší nárůsty",
  跌幅榜: "Největší poklesy",
  成交额榜: "Objemový žebříček",
  关于我们: "O nás",
  登录密码: "Přihlašovací heslo",
  设置: "Nastavení",
  资产密码: "Heslo aktiv",
  修改登录密码: "Změnit přihlašovací heslo",
  原密码: "Staré heslo",
  请输入新密码: "Zadejte nové heslo",
  请输入原密码: "Zadejte staré heslo",
  确认密码: "Potvrdit heslo",
  确定修改: "Potvrdit změnu",
  修改资产密码: "Změnit heslo aktiv",
  验证码: "Ověřovací kód",
  资产密码使用提示: "Tipy pro heslo aktiv",
  "资产密码用于转移、提取资产和交易。":
    "Heslo aktiv se používá k převodu, výběru a obchodování s aktivy.",
  "创建与登录密码不同的资产密码。":
    "Vytvořte si heslo aktiv, které se liší od přihlašovacího hesla.",
  "定期更改您的资产密码。": "Pravidelně měňte své heslo aktiv.",
  提币历史: "Historie výběrů",
  "金额/余额": "Částka/Zůstatek",
  "手续费/折扣": "Poplatek/Sleva",
  自选: "Oblíbené",
  现货: "Spot",
  市价: "Tržní cena",
  止损设置: "Nastavení stop-loss",
  合约K线图: "Graf futures",
  "24H量": "24h objem",
  "24H额": "24h objem (USDT)",
  合作指南: "Průvodce pro partnery",
  盈亏计算: "Výpočet zisku/ztráty",
  当前可用: "Aktuálně dostupné",
  请输入加仓金额: "Zadejte částku pro zvýšení pozice",
  请重新输入加仓金额: "Zadejte znovu částku pro zvýšení pozice",
  平仓数量: "Množství k uzavření",
  欢迎登录: "Vítejte zpět",
  "忘记密码?": "Zapomněli jste heslo?",
  "还没有账号？": "Ještě nemáte účet?",
  立即注册: "Registrovat se nyní",
  繁體中文: "Tradiční čínština",
  找回密码: "Obnovit heslo",
  下一步: "Další",
  注册账户: "Registrovat účet",
  "请输入邀请码(选填)": "Zadejte pozvánkový kód (volitelné)",
  谢邀豪礼: "Bonus za pozvání",
  "24小时邀请好友排名": "24hodinové pořadí pozvánek",
  "*人": "* osob",
  "差*人": "Chybí * osob",
  "已超过10万人，每月轻松赚钱":
    "Přes 100 000 uživatelů, vydělávejte snadno každý měsíc",
  最高: "Maximum",
  邀请链接: "Odkaz pro pozvání",
  "平台和您共享好友在平台（现货、合约、杠杆、闪兑）所产生的手续费":
    "Podílejte se na poplatcích za transakce generovaných vašimi přáteli (spot, futures, páka, rychlá směna).",
  平台和您一起分享手续费:
    "Podílejte se na poplatcích za transakce s platformou",
  "*级": "* úroveň",
  规则: "Pravidla",
  我的好友: "Moji přátelé",
  好友详情: "Podrobnosti o příteli",
  获得好友佣金方案: "Plán provize pro přátele",
  我的等级: "Moje úroveň",
  我的邀请数据: "Moje statistiky pozvánek",
  当前等级: "Aktuální úroveň",
  平台奖励您: "Odměna platformy pro vás",
  最高可获取平台奖励: "Maximální odměna platformy",
  邀请规则: "Pravidla pozvání",
  "邀请*级有效好友": "Pozvěte aktivní přátele na úrovni *",
  好友等级: "Úroveň přítele",
  人: "osob",
  奖金派送: "Výplata bonusu",
  平台奖励: "Odměna platformy",
  "最终解释权归平台所有，若发现异常获取平台奖励，将会扣除所有的奖励，并且冻结账户，资产的损失将无法找回。":
    "Platforma si vyhrazuje právo na konečný výklad. V případě podvodných aktivit budou odměny odebrány a váš účet bude zmrazen. Ztracená aktiva nelze obnovit.",
  "您的账户必须是有效账户，平台判定有效账户条件为（账户充值任何币种）最小* USDT的价值。":
    "Váš účet musí být aktivní, definovaný jako vklad v hodnotě alespoň * USDT v jakékoli kryptoměně.",
  "您邀请的好友，必须是有效下级，平台判定有效下级为（账户充值任何币种）最小* USDT的价值。":
    "Váš pozvaný přítel musí být aktivní nižší úroveň, definovaná jako vklad v hodnotě alespoň * USDT.",
  "邀请人和被邀请者的账号不能同属于一个IP。":
    "Pozvatel a pozvaný nesmí sdílet stejnou IP adresu.",
  "VIP等级由您邀请的*级好友的人数作为考核。":
    "VIP úroveň je určena počtem pozvaných přátel na úrovni *.",
  佣金成分: "Složky provize",
  收益统计: "Statistika výnosů",
  昨日收益: "Včerejší výnos",
  月收益: "Měsíční výnos",
  获取收益: "Získat výnos",
  "总收益：": "Celkový výnos:",
  "*级好友": "Přátelé na úrovni *",
  理财购买: "Koupit finanční produkt",
  期限: "Doba trvání",
  可用金额: "Dostupná částka",
  预估收益: "Odhadovaný výnos",
  申购上限: "Maximální nákup",
  项目剩余: "Zbývající projekt",
  "买入后预计*(SGT)开始计算收益。": "Výnos začne přibližně v *(SGT) po nákupu.",
  计息日: "Začátek úročení",
  申购日: "Datum nákupu",
  到账日: "Datum připsání",
  到期自动续投: "Automatické reinvestování při vypršení",
  申购: "Koupit",
  搜索理财项目: "Hledat finanční produkt",
  超高年化随心选: "Vyberte si z produktů s vysokým výnosem",
  "自由选择理财币种，稳定超额收益":
    "Volně si vyberte svou kryptoměnu pro stabilní, nadprůměrné výnosy",
  理财总资产: "Celková investovaná aktiva",
  申购数量: "Množství k nákupu",
  立即购买: "Koupit nyní",
  年化收益率: "Roční procentuální výnos (APY)",
  理财订单: "Objednávky finančních produktů",
  持有: "V držení",
  申购份额: "Koupený podíl",
  到账日期: "Datum připsání",
  申购成功: "Nákup úspěšný",
  到期: "Vypršelo",
  是否选择做多: "Otevřít long pozici?",
  "可用余额为0 不能操作": "Zůstatek je 0, akce není možná",
  福利中心: "Centrum bonusů",
  奖励记录: "Historie odměn",
  我获取到的奖励: "Moje získané odměny",
  总价值: "Celková hodnota",
  新手任务: "Úkoly pro nové uživatele",
  身份认证: "Ověření identity (KYC)",
  身份验证: "Ověření identity",
  去验证: "Ověřit nyní",
  审核中: "Čeká na zpracování",
  已验证: "Ověřeno",
  认证失败: "Ověření selhalo",
  基础认证: "Základní ověření",
  "请注意认证信息一经验证不能修改，务必填写准确信息":
    "Poznámka: Ověřené informace nelze změnit. Zadejte přesné údaje.",
  "国家/地区": "Země/Region",
  请选择: "Vybrat",
  证件类型: "Typ dokladu",
  证件编码: "Číslo dokladu",
  身份证: "Občanský průkaz",
  护照: "Cestovní pas",
  驾驶证: "Řidičský průkaz",
  请输入编码: "Zadejte číslo",
  名字: "Jméno",
  请输入: "Zadejte",
  中间名: "Prostřední jméno",
  选填: "Volitelné",
  姓氏: "Příjmení",
  中国: "Čína",
  身份上传: "Nahrát doklad totožnosti",
  上传身份证: "Nahrát občanský průkaz",
  "以上材料需要用JPG/JPEG/PNG格式上传，并且保证照片的清晰边角完整，亮度均匀。且大小不超过*M。":
    "Nahrajte ve formátu JPG/JPEG/PNG. Ujistěte se, že jsou obrázky jasné, úplné a rovnoměrně osvětlené. Maximálně *MB.",
  确定提交: "Odeslat",
  去认证: "Ověřit",
  挑战任务: "Výzvové úkoly",
  注册认证任务: "Úkol registrace a ověření",
  完成注册认证即可领取: "Dokončete registraci a ověření a získejte",
  领取奖励: "Převzít odměnu",
  新人豪礼: "Vítací bonus",
  "参与人数：": "Počet účastníků:",
  条件: "Podmínka",
  入金量: "Částka vkladu",
  完成: "Dokončeno",
  任务奖励: "Odměna za úkol",
  距任务更新: "Do aktualizace úkolu",
  "条件：": "Podmínka:",
  活动规则: "Pravidla aktivity",
  奖励明细: "Podrobnosti odměny",
  已获得: "Získáno",
  交易奖励: "Odměna za obchodování",
  Win奖励: "WIN odměna",
  已领取: "Převzato",
  亏损金额超过: "Částka ztráty překračuje",
  单笔开仓金额超过: "Částka jednotlivého příkazu překračuje",
  交易量: "Objem obchodů",
  待完成: "Čeká na dokončení",
  入金: "Vklad",
  盈利金额超过: "Částka zisku překračuje",
  开仓金额: "Částka příkazu",
  开仓金: "Částka příkazu",
  盈利: "Zisk",
  亏损: "Ztráta",
  领取: "Převzít",
  未领取: "Nepřevzato",
  待领取: "Čeká na převzetí",
  再交易: "Obchodujte dále",
  即可获得: "abyste získali",
  领取成功: "Převzetí úspěšné",
  "1、所有的活动都会按照活动最后的时间进行统计收益过期后将无效。":
    "1. Všechny aktivity budou vypořádány k datu ukončení. Odměny po tomto datu vyprší.",
  "2、获得的收益会发放到您的赏金账户中，你可以随时根据您的需要进行兑换和提现。":
    "2. Získaný výnos bude připsán na váš účet odměn, který můžete kdykoli směnit nebo vybrat.",
  "3、获取的到的奖励币种类型根据任务按类型发放。":
    "3. Kryptoměna odměny závisí na úkolu.",
  "4、最终解释权归平台所有，若发现存在异常手段套利平台的任务奖金，平台有权冻结并且清除您获取的收益。":
    "4. Platforma si vyhrazuje právo na konečný výklad. V případě podvádění u úkolů budou odměny zadrženy a váš účet může být zmrazen.",
  成长学院: "Akademie",
  "区块链 & 加密货币": "Blockchain & Kryptoměny",
  "您的加密货币一站式指南，我们带您开启加密货币之路。":
    "Váš kompletní průvodce kryptoměnami. Doprovázíme vás na vaší kryptocestě.",
  "全仓合约定单的全部保证金。":
    "Celková marže pro příkazy futures s křížovou marží.",
  "(账户余额+(浮动盈亏-手续费-过夜费)=净值/已用保证金*100":
    "(Zůstatek + (nerealizovaný zisk/ztráta - poplatky - úroky z financování) = Čistá hodnota / Využitá marže * 100",
  "浮动盈亏会直接影响”可用保证金“，当未实现盈亏增加，可用保证金将会增加，未实现盈亏减少，可用保证金同样也会减少。":
    "Nerealizovaný zisk/ztráta přímo ovlivňuje 'dostupnou marži'. Pokud nerealizovaný zisk/ztráta roste, dostupná marže roste a naopak.",
  "账户余额-(已用保证金)+(浮动盈亏-手续费-过夜费)":
    "Zůstatek - (Využitá marže) + (nerealizovaný zisk/ztráta - poplatky - úroky z financování)",
  "注:可继续用于开仓的保证金。":
    "Poznámka: Marže, která je k dispozici pro otevírání nových pozic.",
  "账户余额+(浮动盈亏-手续费-过夜费)":
    "Zůstatek + (nerealizovaný zisk/ztráta - poplatky - úroky z financování)",
  "注:当前的资金结余。": "Poznámka: Aktuální zůstatek.",
  "指的是合约账户的全部余额，包含不可用余额。":
    "Vztahuje se na celkový zůstatek účtu futures, včetně zmrazených částek.",
  "注:风险率越高，风险越低，风险率越低，风险越高。":
    "Poznámka: Čím vyšší míra rizika, tím nižší riziko a naopak.",
  该功能尚未开发: "Tato funkce je stále ve vývoji",
  重置密码: "Obnovit heslo",
  "请输入为8-20位，必须包含字母、数字和特殊字符":
    "Zadejte 8-20 znaků, včetně písmen, číslic a speciálních znaků",
  修改成功: "Změna úspěšná",
  输入验证码: "Zadejte ověřovací kód",
  输入密码: "Zadejte heslo",
  详情说明: "Podrobnosti",
  已售罄: "Vyprodáno",
  剩余期限: "Zbývající doba",
  限期: "Doba trvání",
  闪兑货币选择: "Výběr měny pro rychlou směnu",
  地区选择: "Výběr regionu",
  "搜索国家/地区": "Hledat zemi/region",
  "身份信息已提交，将在*小时内审核完成":
    "Informace o totožnosti byly odeslány. Zpracování potrvá až * hodin.",
  "选择国家/地区": "Vybrat zemi/region",
  "止盈价格需高于*": "Cena take-profit musí být vyšší než *",
  "止损价格需低于*": "Cena stop-loss musí být nižší než *",
  "止盈价格需低于*": "Cena take-profit musí být nižší než *",
  "止损价格需高于*": "Cena stop-loss musí být vyšší než *",
  教程详情: "Podrobnosti návodu",
  请输入止损价: "Zadejte cenu stop-loss",
  活期: "Flexibilní",
  赎回后立即到账: "Okamžité připsání po zpětném odkupu",
  赎回: "Zpětný odkup",
  赎回理财: "Zpětný odkup finančního produktu",
  是否赎回当前的理财订单:
    "Provést zpětný odkup aktuální objednávky finančního produktu?",
  维护: "Údržba",
  "系统正在维护中……": "Systém je v údržbě...",
  合约: "Futures",
  闪电兑换: "Rychlá směna",
  流水挖矿: "Těžba objemu",
  邀请豪礼: "Bonus za pozvání",
  计算器: "Kalkulačka",
  最新价: "Poslední cena",
  涨跌幅: "Změna (24h)",
  关注币种添加自选: "Přidat kryptoměnu do oblíbených",
  一键添加自选: "Přidat do oblíbených (jedním kliknutím)",
  全标已读: "Označit vše jako přečtené",
  无消息: "Žádné zprávy",
  "暂时还没有收到任何消息通知哦!": "Zatím jste neobdrželi žádná oznámení!",
  没有更多数据: "Žádná další data",
  闪兑: "Rychlá směna",
  从: "Z",
  "可用余额：": "Dostupný zůstatek:",
  至: "Do",
  预览兑换结果: "Náhled výsledku směny",
  闪兑规则: "Pravidla rychlé směny",
  "市场闪兑可能变动，请以实际到账的金额数量为准。":
    "Rychlá směna podléhá tržním výkyvům. Skutečně přijatá částka je závazná.",
  "对汇兑率由第三方制定，由于兑换成本以及市场波动，您兑换的汇率可能会高于市场的汇率，请仔细确认后进行操作。":
    "Směnné kurzy jsou stanoveny třetí stranou. Kvůli nákladům a výkyvům se kurz může lišit od tržního kurzu. Pečlivě zkontrolujte.",
  "平台对每笔汇兑收取大约*%的手续费，用于支付在交易所兑换成本。":
    "Platforma účtuje přibližně *% poplatek za směnu na pokrytí nákladů na burzách.",
  确认汇兑: "Potvrdit směnu",
  您预估得到: "Odhadovaný příjem",
  汇兑: "Směna",
  汇兑比例: "Směnný kurz",
  刷新: "Obnovit",
  兑换: "Směnit",
  没有更多了: "Žádná další data",
  搜索币种: "Hledat kryptoměnu",
  可用: "Dostupné",
  我知道了: "Rozumím",
  最新价格: "Poslední cena",
  确认: "Potvrdit",
  最大: "Maximum",
  "风险率(%)": "Míra rizika (%)",
  当前委托: "Aktuální příkazy",
  合作交易历史记录: "Historie transakcí partnera",
  重置: "Resetovat",
  余额: "Zůstatek",
  现货账户: "Spotový účet",
  合约账户: "Účet futures",
  WIN账户: "WIN účet",
  赏金账户: "Účet odměn",
  总资产折合: "Celková aktiva (v USDT)",
  今日收益: "Dnešní výnos",
  充币: "Vklad",
  提币: "Výběr",
  账户权益: "Hodnota účtu",
  "数量/类别": "Množství/Kategorie",
  全部币种: "Všechny kryptoměny",
  全部类型: "Všechny typy",
  账单信息: "Informace o faktuře",
  理财赎回: "Zpětný odkup finančního produktu",
  购买理财: "Nákup finančního produktu",
  收入: "Příjmy",
  支出: "Výdaje",
  到: "na",
  资产划转: "Převod aktiv",
  "最少*": "Minimálně *",
  "可用资产：": "Dostupná aktiva:",
  确认划转: "Potvrdit převod",
  "只有将资产划转至对于的账户才可以进行交易，账户间的划转不收取手续费。":
    "Abyste mohli obchodovat, musíte převést aktiva na správný účet. Převody mezi účty jsou zdarma.",
  币种账户选择: "Výběr účtu kryptoměny",
  选择账户: "Vybrat účet",
  划转详情: "Podrobnosti převodu",
  划转明细: "Specifikace převodu",
  收入账单: "Faktura příjmů",
  支出账单: "Faktura výdajů",
  金额: "Částka",
  总收益: "Celkový výnos",
  佣金: "Provize",
  用户名: "Uživatelské jméno",
  "已领取：": "Převzato:",
  "未领取：": "Nepřevzato:",
  "请选择国家/地区": "Vyberte zemi/region",
  请上传身份信息: "Nahrajte informace o totožnosti",
  请选择证件类型: "Vyberte typ dokladu",
  请填写证件编码: "Zadejte číslo dokladu",
  请填写名字: "Zadejte jméno",
  请填写姓氏: "Zadejte příjmení",
  投资金额: "Částka investice",
  天: "dní",
  请输入手机号: "Zadejte telefonní číslo",
  搜索: "Hledat",
  搜索历史: "Historie vyhledávání",
  热门推荐: "Populární doporučení",
  "《Xspace Earn协议》": "Protokol Xspace Earn",
  我已了解并同意: "Rozumím a souhlasím",
  协议: "Protokol",
  Xspace官方中文交流群: "Oficiální čínská komunita Xspace",
  Xspace官方英文交流群: "Oficiální anglická komunita Xspace",
  预计维护至: "Předpokládaná údržba do",
  更多功能: "Více funkcí",
  下载APP: "Stáhnout aplikaci",
  理财: "Finanční produkt",
  推荐: "Doporučené",
  Telegram官方中文频道: "Oficiální Telegram kanál (čínština)",
  Telegram官方英文频道: "Oficiální Telegram kanál (angličtina)",
  官方邮箱: "Oficiální e-mail",
  客服邮箱: "E-mail zákaznické podpory",
  上述信息最终解释权归官方所有:
    "Výše uvedené informace podléhají oficiálnímu výkladu platformy.",
  IOS版下载: "Stáhnout pro iOS",
  Android版下载: "Stáhnout pro Android",
  "手续费=买入手续费+资金费率+卖出手续费":
    "Poplatek za transakci = Poplatek za nákup + Sazba financování + Poplatek za prodej",
  资金划转: "Převod prostředků",
  止盈: "Take-profit",
  止损: "Stop-loss",
  自动平仓: "Automatické uzavření",
  委托挂单: "Otevřený příkaz",
  买: "Koupit",
  卖: "Prodat",
  "买入/做多": "Koupit/Long",
  "卖出/做空": "Prodat/Short",
  详情: "Podrobnosti",
  浮动涨跌: "Nerealizovaný zisk/ztráta",
  最小: "Minimum",
  充币数量: "Množství vkladu",
  请输入充币数量: "Zadejte množství vkladu",
  支付截图: "Doklad o platbě",
  提交: "Odeslat",
  上传驾驶证: "Nahrát řidičský průkaz",
  上传护照: "Nahrát cestovní pas",
  加载中: "Načítání...",
  上传成功: "Nahrání úspěšné",
  充值历史: "Historie vkladů",
  合约卖出手续费: "Poplatek za prodej futures",
  合约买入手续费: "Poplatek za nákup futures",
  系统加款: "Systémové připsání",
  系统减款: "Systémové odepsání",
  合约资金费率: "Sazba financování futures",
  佣金分成: "Dělení provize",
  U本位合约: "Futures s marží v USDT",
  资产管理: "Správa aktiv",
  APP下载: "Stáhnout aplikaci",
  全球领先的数字理财平台:
    "Celosvětově přední platforma pro digitální správu majetku",
  "即刻交易比特币、以太坊等上百种数字资产":
    "Obchodujte okamžitě s Bitcoinem, Ethereum a stovkami dalších digitálních aktiv",
  "24H涨跌幅": "24h změna",
  查看更多行情: "Zobrazit více trhů",
  近24小时成交量: "24h objem",
  "提供数百种币币和合约交易对，以满足多样化的交易需求。 平台在200个国家和地区中有超过2千万用户，是全球领先的数字资产服务平台。":
    "Nabízí stovky spotových a futures párů. Přes 20 milionů uživatelů ve více než 200 zemích. Celosvětově přední platforma pro digitální aktiva.",
  用户国家分布: "Uživatelé podle zemí",
  用户数: "Počet uživatelů",
  交易对: "Obchodní páry",
  服务支持: "Podpora",
  "随时随地，多平台终端交易": "Obchodujte kdekoli s podporou více platforem",
  "多终端完美兼容，随时满足各种场景的交易需求。":
    "Kompatibilní s více zařízeními pro všechny potřeby obchodování.",
  随时查看实时行情: "Sledujte ceny v reálném čase kdekoli",
  "轻松买卖BTC，ETH，DOGE和其他数字资产":
    "Snadno nakupujte a prodávejte BTC, ETH, DOGE a další digitální aktiva",
  获取您关注的加密货币价格变化预警:
    "Získejte cenová upozornění pro kryptoměny, které sledujete",
  "查看比特币现货、期货、期权价格":
    "Podívejte se na ceny Bitcoin spot, futures a opcí",
  比较各交易所加密货币价格: "Porovnejte ceny kryptoměn napříč burzami",
  开启您的数字货币之旅: "Zahajte svou cestu s digitálními aktivy",
  快捷购买数字货币: "Rychle nakupujte kryptoměny",
  "使用多种支付方式交易数字货币，安全快捷":
    "Obchodujte bezpečně a rychle s více platebními metodami",
  最优的交易费率: "Nejlepší poplatky za transakce",
  "优惠的交易费率，富有竞争力的VIP权益，享受最优品质的服务":
    "Výhodné sazby, konkurenceschopné VIP výhody a služby nejvyšší kvality.",
  可信赖的安全保障: "Spolehlivé zabezpečení",
  "我们复杂的安全措施和SAFU基金保护您的数字资产免受所有风险。":
    "Pokročilá bezpečnostní opatření a fond SAFU chrání vaše aktiva před riziky.",
  交易: "Obchodovat",
  币币市场: "Spotový trh",
  "24H成交量": "24h objem",
  交易所: "Burza",
  "24H最高": "24h maximum",
  "24H最低": "24h minimum",
  永续合约: "Perpetuální futures",
  日涨跌: "Denní změna",
  交易深度: "Hloubka knihy příkazů",
  "资产(合约)": "Aktiva (Futures)",
  历史仓位: "Historie pozic",
  兑换记录: "Historie směn",
  类型: "Typ",
  充值记录: "Historie vkladů",
  划转记录: "Historie převodů",
  类别: "Kategorie",
  历史账单: "Historie faktur",
  在线充值: "Online vklad",
  安全设置: "Bezpečnostní nastavení",
  用于账户登录使用: "Používá se pro přihlášení k účtu",
  用户提现时安全验证使用: "Používá se pro bezpečnostní ověření při výběrech",
  验证: "Ověřit",
  万: "milion",
  随时随地开启交易: "Začněte obchodovat kdekoli",
  "*货币交易所的所有功能尽在你的手中。":
    "Všechny funkce * kryptoměnové burzy ve vašich rukou.",
  "下载*货币交易所APP。": "Stáhněte si aplikaci * kryptoměnové burzy.",
  下载自: "Stáhnout z",
  内测版: "Beta verze",
  下载: "Stáhnout",
  扫码下载: "Skenujte pro stažení",
  设置您的资产密码: "Nastavte své heslo aktiv",
  法币: "Fiat",
  我要买: "Chci koupit",
  我要卖: "Chci prodat",
  请输入金额: "Zadejte částku",
  汇率: "Směnný kurz",
  获得: "Získat",
  支付通道: "Platební kanál",
  收款通道: "Přijímací kanál",
  "出售过程需要务必确认好您的收款方式为本人。":
    "Při prodeji se ujistěte, že přijímací kanál je na vaše jméno.",
  当前法币暂不支持交易对可尝试前往提现:
    "Tento fiat pár není v současné době podporován. Zkuste výběr.",
  前往提现: "Přejít na výběr",
  该法币暂无通道: "Pro tuto fiat měnu není k dispozici žádný kanál",
  "正在出售中，请耐心等待": "Prodej probíhá, čekejte prosím",
  请选择支付通道: "Vyberte platební kanál",
  请选择方式: "Vyberte metodu",
  法币历史: "Historie fiat",
  买币: "Koupit kryptoměnu",
  卖币: "Prodat kryptoměnu",
  失败: "Neúspěšné",
  已完成: "Dokončeno",
  未付款: "Nezaplaceno",
  待审核: "Čeká na zpracování",
  打款中: "Platba probíhá",
  订单详情: "Podrobnosti objednávky",
  联系客服: "Kontaktovat podporu",
  到账金额: "Přijatá částka",
  通道: "Kanál",
  收款人: "Příjemce",
  收款账户: "Účet příjemce",
  "订单出售失败，请查下方失败原因":
    "Prodej objednávky selhal. Podívejte se na důvod níže.",
  失败原因: "Důvod selhání",
  您还未进行付款: "Zatím jste nezaplatili",
  您已成功购买: "Nákup byl úspěšný",
  已取消订单: "Objednávka zrušena",
  "订单正在审核中，请耐心等待": "Objednávka se zpracovává. Čekejte prosím.",
  您已成功出售: "Prodej byl úspěšný",
  "订单正在打款中，请耐心等待": "Platba probíhá. Čekejte prosím.",
  "支付过程需要您前往其他的平台进行支付订单，请注意信息安全。":
    "Pro platbu musíte navštívit jinou platformu. Dbejte na bezpečnost svých informací.",
  当前法币暂不支持交易对可尝试前往充值:
    "Tento fiat pár není v současné době podporován. Zkuste vklad.",
  前往充值: "Přejít na vklad",
  购买: "Koupit",
  订单号: "Číslo objednávky",
  单价: "Jednotková cena",
  到账数量: "Přijaté množství",
  "当前存在未付的订单，是否继续发起新的支付订单？":
    "Existuje nezaplacená objednávka. Chcete zahájit nový platební příkaz?",
  继续支付: "Pokračovat v platbě",
  重新下单: "Nová objednávka",
  是否确定出售: "Opravdu chcete prodat?",
  "确定出售后，平台将分配给买家，请耐心等待平台的撮合。":
    "Po potvrzení platforma přiřadí kupujícího. Počkejte na spárování.",
  出售: "Prodat",
  收款方式: "Způsob přijetí",
  订单已生成: "Objednávka vygenerována",
  取消订单: "Zrušit objednávku",
  请在: "Prosím do",
  内完成付款: "dokončete platbu",
  "离开平台，登录您指定的支付，转账到卖家的以下账户，并务必在付款中备注：":
    "Opusťte platformu, přihlaste se ke své zvolené platební metodě a převeďte částku na následující účet prodejce. Vždy uveďte referenci:",
  "若付款时未进行备注，卖家将无法确认收款，造成资产损失无法找回。":
    "Bez reference prodejce nemůže potvrdit platbu, což může vést ke ztrátě aktiv.",
  "未在规定的时间内付款，订单都将被取消。":
    "Pokud nezaplatíte v daném čase, objednávka bude zrušena.",
  姓名: "Jméno",
  收款姓名: "Jméno příjemce",
  开户支行: "Pobočka banky",
  银行卡号: "Číslo bankovní karty",
  "付款后，返回本平台": "Po zaplacení se vraťte na tuto platformu",
  "请务必点击下方“我已完成付款，通知卖家”按钮":
    "Klikněte na tlačítko 'Dokončil jsem platbu, upozornit prodejce'",
  未点击卖家不会放款: "Prodejce uvolní kryptoměnu až po kliknutí na tlačítko",
  交易条款: "Obchodní podmínky",
  "购买资金来源，必须合法安全的资金，方可交易":
    "Prostředky pro nákup musí být legální a bezpečné",
  "不允许诈骗、传销、赌博或者其他非法资金交易":
    "Podvody, pyramidové hry, hazardní hry nebo jiné nelegální prostředky nejsou povoleny",
  "交易完成后，出现资金风险，被冻结或者涉嫌欺诈、传销、赌博的资金，我方将不在向买方放U，并给予退款":
    "Pokud budou po transakci prostředky zmrazeny nebo podezřelé, neuvolníme USDT a poskytneme refundaci",
  "已付款，通知卖家": "Zaplaceno, upozornit prodejce",
  "买方当日累计取消*笔订单，将会取消当日购买功能。确定取消该订单吗？":
    "Pokud dnes zrušíte celkem * objednávek, vaše právo na nákup bude na dnešek zrušeno. Zrušit tuto objednávku?",
  添加收款方式: "Přidat způsob přijetí",
  是否删除此收款方式: "Smazat tento způsob přijetí?",
  删除: "Smazat",
  请选择法币: "Vyberte fiat měnu",
  机构名称: "Název instituce",
  请选择机构: "Vyberte instituci",
  "当您出售数字货币时，您选择的收款方式将向买方展示，请确认填写无误。":
    "Váš vybraný způsob přijetí bude zobrazen kupujícím, když prodáváte kryptoměnu. Ujistěte se, že údaje jsou správné.",
  请选择银行: "Vyberte banku",
  请输入姓名: "Zadejte jméno",
  账号: "Číslo účtu",
  请输入账号: "Zadejte číslo účtu",
  收款码: "Přijímací kód",
  "银行账号/卡号": "Bankovní účet/Číslo karty",
  "请输入银行账号/卡号": "Zadejte bankovní účet/číslo karty",
  "开户支行（选填）": "Pobočka banky (volitelné)",
  请输入开户支行: "Zadejte pobočku banky",
  "加入*官方频道": "Připojte se k oficiálnímu kanálu *",
  关于: "O nás",
  条款: "Podmínky",
  成功: "Úspěch",
  等待: "Čekání",
  作废: "Neplatné",
  确认付款: "Potvrdit platbu",
  "是否已完成付款？若确认付款后，商家将会在*分内进行确认是否收到付款。":
    "Platba dokončena? Po potvrzení prodejce potvrdí přijetí do * minut.",
  最大金额: "Maximální částka",
  最小金额: "Minimální částka",
  付款: "Zaplatit",
  法币充值: "Vklad fiat",
  法币提现: "Výběr fiat",
  待支付: "K zaplacení",
  已支付: "Zaplaceno",
  商户名: "Jméno prodejce",
  当前没有添加支付方式: "Nebyla přidána žádná platební metoda",
  添加后再出售: "Přidejte jednu před prodejem",
  新人大礼包: "Vítací balíček",
  注册即可领取: "Získejte po registraci",
  立即领取: "Převzít nyní",
  不再提示: "Znovu nezobrazovat",
  "该奖励需在APP中领取，请下载APP":
    "Tuto odměnu lze převzít pouze v aplikaci. Stáhněte si aplikaci.",
  去交易: "Přejít k obchodování",
  期权交易: "Obchodování s opcemi",
  交易额: "Objem obchodu",
  可用额度: "Dostupný limit",
  交易周期: "Období obchodu",
  看涨: "Růst (Call)",
  看跌: "Pokles (Put)",
  看空: "Short",
  当前持有: "Aktuální pozice",
  胜率: "Úspěšnost",
  "盈利/亏损数": "Počet transakcí se ziskem/ztrátou",
  累计实现盈亏: "Realizovaný celkový zisk/ztráta",
  秒: "sekund",
  分: "minut",
  小时: "hodin",
  周: "týden",
  下单时间: "Čas objednávky",
  剩余时间: "Zbývající čas",
  买入价: "Nákupní cena",
  结算价: "Vypořádací cena",
  实现盈利: "Realizovaný zisk",
  结算时间: "Čas vypořádání",
  期权: "Opce",
  新手教程: "Průvodce pro začátečníky",
  我的订单: "Moje objednávky",
  赔率: "Kurz",
  全部订单: "Všechny objednávky",
  持有订单: "Otevřené objednávky",
  历史订单: "Historie objednávek",
  输入交易额度: "Zadejte částku obchodu",
  选择交易周期: "Vyberte období obchodu",
  去注册: "Registrovat",
  冻结: "Zmrazit",
  期权支出: "Výdaj na opci",
  期权收入: "Příjem z opce",
  用户提现: "Výběr uživatele",
  "是否购买？": "Koupit tuto opci?",
  购买成功: "Nákup úspěšný",
  请签名: "Prosím podepište",
  提交签名: "Odeslat podpis",
  清空签名: "Vymazat podpis",
  签名审核中: "Podpis se zpracovává",
  已提交: "Odesláno",
  扫一扫下载APP: "Skenujte pro stažení aplikace",
  新手领取大礼包: "Vítací balíček pro nové uživatele",
  注册实名即送彩金: "Zaregistrujte se a ověřte se a získejte bonus",
  交易总额: "Celkový objem obchodů",
  资产不足: "Nedostatek aktiv",
  "Win账户的资产不足，可从资金账户划转至此账户":
    "Nedostatek aktiv na WIN účtu. Aktiva můžete převést ze svého hlavního účtu.",
  Win: "WIN",
  比赛: "Soutěž",
  未开始: "Nezačalo",
  赛程: "Program",
  赛果: "Výsledek",
  已结束: "Ukončeno",
  让球: "Handicap",
  进球数: "Góly",
  大: "Nad",
  小: "Pod",
  胜负平: "1X2 (Výhra/Remíza/Prohra)",
  和局: "Remíza",
  投注: "Sázka",
  下注金额: "Částka sázky",
  下注: "Vsadit",
  阵容: "Sestava",
  分析: "Analýza",
  输入下注金额: "Zadejte částku sázky",
  下注成功: "Sázka úspěšná",
  投注记录: "Historie sázek",
  未结算: "Nevyrovnáno",
  已结算: "Vyrovnáno",
  流水: "Obrat",
  输赢: "Zisk/Strata",
  赛时: "Čas zápasu",
  下注时间: "Čas sázky",
  足彩竞猜: "Fotbalové tipování",
  查看详情: "Zobrazit podrobnosti",
  输: "Prohra",
  赢: "Výhra",
  主: "Domácí",
  客: "Hosté",
  主胜: "Výhra domácích",
  客胜: "Výhra hostů",
  平: "Remíza",
  已延期: "Odloženo",
  账号异常: "Anomálie účtu",
  全场独赢: "Celý zápas 1X2",
  全场让球: "Celý zápas Handicap",
  全场大小: "Celý zápas Nad/Pod",
  总进球: "Celkový počet gólů",
  拍摄照片要求: "Požadavky na fotografii",
  标准拍摄: "Standardní fotografie",
  边框缺失: "Chybějící okraj",
  照片模糊: "Rozmazaná fotografie",
  闪光强烈: "Příliš silný blesk",
  上传手持证件照: "Nahrát fotografii s dokumentem v ruce",
  上传证件照: "Nahrát fotografii dokumentu",
  换一张: "Nová fotografie",
  出生日期: "Datum narození",
  请选择出生日期: "Vyberte datum narození",
  "输入下方正确的图形验证后，获取邮箱验证码进行注册":
    "Zadejte níže uvedený ověřovací kód pro získání e-mailového kódu pro registraci.",
  "您还剩余*次认证次数，超出次数将无法继续认证":
    "Zbývá vám ještě * pokusů o ověření. Po překročení tohoto limitu se nebudete moci ověřit.",
  上半场: "1. poločas",
  下半场: "2. poločas",
  独赢: "1X2",
  上半场独赢: "1. poločas 1X2",
  下半场独赢: "2. poločas 1X2",
  上半场让球: "1. poločas Handicap",
  下半场让球: "2. poločas Handicap",
  上半场大小球: "1. poločas Nad/Pod",
  下半场大小球: "2. poločas Nad/Pod",
  波胆: "Přesný výsledek",
  上半场波胆: "1. poločas Přesný výsledek",
  下半场波胆: "2. poločas Přesný výsledek",
  单双: "Lichý/Sudý",
  单: "Lichý",
  双: "Sudý",
  上半场单双: "1. poločas Lichý/Sudý",
  下半场单双: "2. poločas Lichý/Sudý",
  上半场总进球: "1. poločas Celkový počet gólů",
  下半场总进球: "2. poločas Celkový počet gólů",
  中场: "Poločas",
  "注意：手持证件照请按照此示例图在白纸上书写文字并与证件一起拍摄":
    "Poznámka: Pro fotografii s dokumentem v ruce napište text na bílý papír a vyfoťte jej společně se svým dokumentem, jako v příkladu.",
  "近期发现大量作弊账户，对一批违规账户进行了惩罚。如果有误判为违规账户，请联系在线客服。":
    "Nedávno bylo potrestáno mnoho podvodných účtů. Kontaktujte zákaznickou podporu, pokud se domníváte, že váš účet byl potrestán nespravedlivě.",
  最小下注金额: "Minimální sázka",
  参与活动最小下注金额: "Minimální sázka pro účast v aktivitě",
  记住密码: "Zapamatovat heslo",
  比分: "Skóre",
  "您还未登录，请先登录": "Nejste přihlášeni. Nejprve se přihlaste.",
  立即登录: "Přihlásit se nyní",
  下注限额: "Limit sázky",
  可赢金额: "Částka, kterou lze vyhrát",
  闪兑详情: "Podrobnosti rychlé směny",
  大小球: "Nad/Pod",
  "由于汇率原因，下注金额和实际下注金额会有误差，请以订单为准。":
    "Kvůli kolísání směnných kurzů se může konečná částka sázky lišit. Objednávka je závazná.",
  开赛时间: "Čas začátku",
  足球收入: "Příjmy z fotbalu",
  足球支出: "Výdaje na fotbal",
  活动详情: "Podrobnosti aktivity",
  为世界杯喝彩: "Podpořte mistrovství světa",
  我的竞猜: "Moje tipy",
  "竞猜比赛、有机会瓜分*USDT": "Tipujte zápasy a vyhrajte část z * USDT",
  "瓜分*USDT": "Rozdělte si * USDT",
  距离活动结束还有: "Do konce aktivity zbývá:",
  我的门票: "Moje vstupenky",
  竞猜结束时间: "Konec tipování",
  猜比分: "Tipovat výsledek",
  "福利派送中，完成任务即可获取门票":
    "Bonusy jsou rozdávány. Dokončete úkoly a získejte vstupenky.",
  "完成如下任务，可获对应数量门票的参与竞赛":
    "Dokončete následující úkoly a získejte odpovídající počet vstupenek pro účast v soutěži.",
  时: "hodina",
  活动: "Aktivita",
  竞猜记录: "Historie tipů",
  结果: "Výsledek",
  任务: "Úkol",
  去邀请: "Pozvat",
  "每场比赛的比分竞猜，参与竞猜可瓜分$*美金的奖励。":
    "Tipujte výsledek každého zápasu a vyhrajte část z $*.",
  "参与竞猜需要门票，门票可按照平台的任务进行获得。":
    "K tipování je potřeba vstupenka. Vstupenky lze získat dokončením úkolů platformy.",
  "竞猜成功后，把竞猜结果的截图发送给客服，客服会把奖金划入您的资金账户，你可以立即提取。":
    "Po úspěšném tipu pošlete snímek obrazovky podpoře. Připíší bonus na váš účet, který můžete okamžitě vybrat.",
  "禁止任何作弊行为、如果发现作弊行为，奖励无效。":
    "Podvádění je zakázáno. Pokud bude odhaleno, odměna bude zrušena.",
  "完成任务后，点击咨询客服获得门票。":
    "Po dokončení úkolů klikněte na 'Kontaktovat podporu' a získejte vstupenky.",
  继续猜: "Pokračovat v tipování",
  总单数: "Celkový počet sázek",
  赛事筛选: "Filtrovat podle události",
  球队筛选: "Filtrovat podle týmu",
  总金额: "Celková částka",
  总流水: "Celkový obrat",
  派奖金额: "Vyplacená částka bonusu",
  下注单数: "Počet sázek",
  利润: "Zisk",
  更多福利: "Více bonusů",
  我的奖金: "Můj bonus",
  未认证: "Neověřeno",
  总量: "Celkem",
  或: "nebo",
  模拟交易: "Demo obchodování",
  体验账户不可操作: "Není k dispozici na demo účtu",
  世界杯比分竞猜: "Tipování výsledků MS",
  "领*USDT起": "Získejte od * USDT",
  消息: "Zprávy",
  滚球: "Živé sázky",
  是: "Ano",
  不是: "Ne",
  当前余额: "Aktuální zůstatek",
  KOL招募: "Nábor KOL",
  本月净输赢: "Čistý zisk/ztráta tento měsíc",
  本月佣金: "Provize tento měsíc",
  佣金比例: "Procento provize",
  活跃人数: "Aktivní uživatelé",
  新增下级: "Nové nižší úrovně",
  登录人数: "Přihlášení uživatelé",
  首存人数: "Uživatelé s prvním vkladem",
  数据分析: "Analýza dat",
  人数: "Počet osob",
  新注册存款金额: "Částka vkladů nových registrací",
  老用户存款金额: "Částka vkladů stávajících uživatelů",
  首存金额: "Částka prvního vkladu",
  快捷入口: "Rychlý přístup",
  成员管理: "Správa členů",
  财务报表: "Finanční výkazy",
  分红报表: "Zpráva o dividendách",
  订单记录: "Historie objednávek",
  VIP专享: "VIP exkluzivně",
  推广工具: "Propagační nástroje",
  计算规则: "Pravidla výpočtu",
  账变明细: "Podrobnosti transakce",
  成员: "Členové",
  下级概览: "Přehled nižších úrovní",
  下级成员总计: "Nižší úrovně celkem",
  本月新增: "Noví tento měsíc",
  本月活跃会员: "Aktivní členové tento měsíc",
  今日活跃会员: "Aktivní členové dnes",
  本月有效活跃: "Efektivně aktivní tento měsíc",
  活跃成员占比: "Podíl aktivních členů",
  本月活跃: "Aktivní tento měsíc",
  今日活跃: "Aktivní dnes",
  下级成员: "Nižší úrovně",
  会员账号: "Účet člena",
  统计时间: "Čas statistiky",
  筛选: "Filtrovat",
  存款: "Vklad",
  取款: "Výběr",
  总输赢: "Celkový zisk/ztráta",
  是否有效用户: "Aktivní uživatel?",
  最近登录时间: "Poslední přihlášení",
  否: "Ne",
  开始时间: "Čas začátku",
  结束时间: "Čas konce",
  提取: "Vybrat",
  总盈亏: "Celkový výsledek",
  净盈亏: "Čistý výsledek",
  分红: "Dividenda",
  概览: "Přehled",
  月度详细数据: "Měsíční podrobná data",
  未发放: "Nevyplaceno",
  活跃用户: "Aktivní uživatelé",
  有效新增会员: "Efektivní noví členové",
  冲正后净输赢: "Čistý zisk/ztráta po opravě",
  上月结余: "Zůstatek z předchozího měsíce",
  净输赢: "Čistý zisk/ztráta",
  "系统每日新加坡时间1:00更新一次报表":
    "Zprávy se aktualizují denně v 01:00 singapurského času.",
  "报表中数据、总输赢、净输赢中正数表示代理方盈利、负数表示代理方亏损":
    "Ve zprávách znamenají kladná čísla zisk pro partnera, záporná čísla znamenají ztrátu pro partnera.",
  "佣金数据每天进行更新，仅供参考，并不做实际佣金派发标准":
    "Údaje o provizi jsou aktualizovány denně, jsou orientační a nepředstavují konečný základ pro výplatu.",
  选择时间: "Vybrat čas",
  足球: "Fotbal",
  投注金额: "Částka sázky",
  有效订单: "Platné objednávky",
  下级账户: "Účet nižší úrovně",
  待成交: "Čeká na vyřízení",
  下单金额: "Částka objednávky",
  订单内容: "Obsah objednávky",
  秒数: "Sekundy",
  联赛: "Liga",
  队伍: "Tým",
  比赛时间: "Čas zápasu",
  玩法: "Typ sázky",
  等级规则表: "Tabulka pravidel úrovní",
  等级: "Úroveň",
  活跃会员: "Aktivní členové",
  最新活跃: "Nejnovější aktivita",
  额外佣金: "Extra provize",
  "每月按照对应等级的增长标准与奖励制度执行，只可享受一个等级奖励。":
    "Měsíčně na základě standardů růstu. Můžete mít prospěch pouze z jedné úrovně.",
  渠道生成: "Generování kanálu",
  创建: "Vytvořit",
  渠道名称: "Název kanálu",
  注册人数: "Počet registrací",
  浏览人数: "Počet zobrazení",
  构建状态: "Stav výstavby",
  禁用: "Zakázat",
  启用: "Povolit",
  查看: "Zobrazit",
  创建渠道: "Vytvořit kanál",
  创建成功: "Vytvoření úspěšné",
  操作成功: "Akce úspěšná",
  渠道详情: "Podrobnosti kanálu",
  邀请码: "Pozvánkový kód",
  访问人数: "Počet návštěvníků",
  渠道地址: "Adresa kanálu",
  我的福利: "Moje bonusy",
  充值福利: "Bonus za vklad",
  当前流水: "Aktuální obrat",
  如何参与: "Jak se zapojit",
  币种充值: "Vklad kryptoměny",
  充值福利中领取福利: "Převzít bonus při bonusu za vklad",
  "规则：充值福利自愿领取，有效期为充值后的24小时内，过期无效，领取后将暂时锁定提现功能，当流水达到后即可解锁提现。":
    "Pravidlo: Bonus za vklad je dobrovolný, platný 24 hodin po vkladu. Po převzetí bude výběr dočasně zablokován, dokud není dosaženo požadovaného obratu.",
  失效日期: "Datum vypršení platnosti",
  "暂无福利领取，充值后领取":
    "Žádný bonus není k dispozici. Převzít po vkladu.",
  参与: "Zúčastnit se",
  充值赠送: "Bonus za vklad",
  "领取*%的赠送": "Převzít *% bonus",
  去领取: "Převzít",
  VIP奖励: "VIP odměna",
  "当前可领取*USDT，是否确认领取": "* USDT k dispozici k převzetí. Potvrdit?",
  "领取后将临时锁定提现功能，当您的流水到达*USDT后即可解除锁定":
    "Po převzetí bude výběr dočasně zablokován, dokud není dosaženo obratu * USDT.",
  充值送大礼: "Dárek za vklad",
  "存入越多，送越多！": "Čím více vložíte, tím větší dárek!",
  无效: "Neplatné",
  有效: "Platné",
  总存金额: "Celková vložená částka",
  提示: "Poznámka",
  "总输赢，净输赢中正数表示平台盈利，负数表示亏损，每天数据只做参考，并不做实际佣金派发标准。":
    "Kladná čísla v celkovém a čistém zisku/ztrátě znamenají zisk platformy. Denní údaje jsou orientační.",
  "净盈亏：总盈亏-用户返水":
    "Čistý výsledek: Celkový výsledek - Vrácení peněz uživateli",
  盈利方: "Strana se ziskem",
  代理: "Agent",
  客户: "Klient",
  平局: "Remíza",
  平台: "Platforma",
  "已提交审核，请耐心等待": "Odesláno k ověření. Čekejte prosím.",
  充值日期: "Datum vkladu",
  平台本月总输赢: "Celkový zisk/ztráta platformy tento měsíc",
  KOL招募合作: "Spolupráce na náboru KOL",
  "平台现在开放【KOL招募活动】，只要您有社群媒体号，就可以和平台享受分红一次性推广客户，就可以享受终生收益。":
    "Platforma otevírá nábor KOL. S účtem na sociálních sítích můžete využívat dividendy a celoživotní příjem prostřednictvím jednorázového získávání zákazníků.",
  级别: "Úroveň",
  平台利润返佣: "Provize ze zisku platformy",
  佣金案例: "Příklad provize",
  交易项目: "Obchodní produkty",
  "期权交易、合约交易、足球游戏":
    "Obchodování s opcemi, obchodování futures, fotbalové hry",
  报名方式: "Způsob přihlášení",
  点击KOL招募报名: "Klikněte pro přihlášení k náboru KOL",
  "欢迎加入我们的团队，平台全面扶持您建立属于自己的用户体系，最高可得*的佣金，我们期待您加入。":
    "Vítejte v našem týmu. Podporujeme vás při budování vlastního uživatelského systému. Získejte až *% provize. Těšíme se na vaši účast.",
  输入联系方式: "Zadejte kontaktní údaje",
  最低活跃人数: "Minimální počet aktivních uživatelů",
  "如：本月活跃人数≥*并且本月平台总输赢≥*USDT，您属于等级*，即可得到*%的佣金。":
    "Např.: Pokud aktivní uživatelé tento měsíc ≥ * a celkový zisk/ztráta platformy ≥ * USDT, patříte do úrovně * a získáte *% provize.",
  比分竞猜: "Tipování výsledku",
  豪礼相赠: "Velký dárek",
  足球活动: "Fotbalová aktivita",
  圣诞节活动: "Vánoční aktivita",
  "您参加了活动，临时锁定提现功能，还需*USDT流水就可以解除锁定。":
    "Zúčastnili jste se aktivity. Výběr je dočasně zablokován. K odblokování potřebujete ještě * USDT obratu.",
  剩余流水: "Zbývající obrat",
  助力足球: "Podpořte fotbal",
  佣金累计: "Provize celkem",
  有效投注: "Platné sázky",
  今日: "Dnes",
  今日返水: "Vrácení peněz dnes",
  VIP返水: "VIP vrácení peněz",
  返水记录: "Historie vrácení peněz",
  成员信息: "Informace o členovi",
  基本信息: "Základní informace",
  钱包余额: "Zůstatek peněženky",
  投注信息: "Informace o sázce",
  返水: "Vrácení peněz",
  总下注: "Celková sázka",
  今日输赢: "Zisk/ztráta dnes",
  下注动态: "Aktivita sázek",
  返水奖励: "Odměna za vrácení peněz",
  分红金额: "Částka dividendy",
  返水支出: "Výdaj na vrácení peněz",
  总返水: "Celkové vrácení peněz",
  流水总额: "Celkový obrat",
  返水总额: "Celkové vrácení peněz",
  返水详情: "Podrobnosti vrácení peněz",
  日流水: "Denní obrat",
  "平台根据你下级每日流水进行额外返水奖励,奖励每日新加坡时间00：00进行派发至赏金账户":
    "Platforma poskytuje dodatečné vrácení peněz na základě denního obratu vašich nižších úrovní. Výplata denně v 00:00 singapurského času na účet odměn.",
  "申请成功，等待审核": "Žádost úspěšná, čeká na ověření",
  "我出本金，盈利共分享": "Já dávám kapitál, zisk se dělí",
  最高分红: "Maximální dividenda",
  投资大师比赛: "Soutěž Mistr investor",
  "我出本金，你盈利": "Já dávám kapitál, ty vyděláváš",
  共分享: "Sdílet společně",
  最高分红可得: "Maximální možná dividenda",
  "新用户专属福利来袭，免费赠送$*，领取后即可投资平台任何项目，盈利后立即可提取。":
    "Exkluzivní vítací bonus: $* zdarma. Po převzetí můžete investovat do libovolného projektu. Zisk je okamžitě vybratelný.",
  报名领取: "Přihlásit se a převzít",
  审核驳回: "Ověření zamítnuto",
  驳回原因: "Důvod zamítnutí",
  活动运行周期: "Doba trvání aktivity",
  "申请成功后起至*天内完成超额收益。":
    "Dosáhněte nadměrného výnosu do * dnů od schválení.",
  分红比: "Poměr dividendy",
  "*日获得盈利后，可获得*%的收益额。":
    "Po dosažení zisku v den * získáte *% z částky výnosu.",
  参与条件: "Podmínky účasti",
  "俄罗斯、土耳其地区的用户，且未参与。":
    "Uživatelé z Ruska nebo Turecka, kteří se ještě nezúčastnili.",
  计算项目: "Vypočítané produkty",
  "合约、体育、期权": "Futures, Sport, Opce",
  我的投资: "Moje investice",
  参与天数: "Dny účasti",
  累计下注: "Celková sázka",
  累计盈亏: "Celkový zisk/ztráta",
  预计可分红: "Očekávaná dividenda",
  常见问题: "Často kladené otázky (FAQ)",
  什么是平台出资: "Co je financování platformy?",
  "平台根据部分国家的用户，免费提供资金让用户去投项目。":
    "Platforma poskytuje bezplatné prostředky uživatelům z určitých zemí k investování do projektů.",
  怎么获取平台出资的福利: "Jak získám bonus financování platformy?",
  "您是指定国家的用户即可，点击上方报名按钮，当平台审核完成后将会把*USDT转入当前账户下的赏金账户，您可划转至其他账户下进行投资。":
    "Pokud jste z jedné z určených zemí, klikněte na tlačítko přihlášení. Po schválení bude * USDT převedeno na váš účet odměn, který můžete převést k investování.",
  什么是分红: "Co je dividenda?",
  "分红指在规定时间内，收益额到达100%后，可分得超额收益的50%。例如：领取100USDT资金，收益额度是120%。":
    "Dividenda: Pokud výnos dosáhne 100% v daném čase, získáte 50% nadměrného výnosu. Příklad: Získejte 100 USDT, dosáhněte 120% výnosu, pak je 20% nadměrný výnos.",
  "如何取得分红？": "Jak získám dividendu?",
  "活动周期每*天1次，活动结束后进行核算，满足活动要求后分红派发至赏金账户。若你未达到活动要求，系统将自动清除你的收益额和平台的出资。":
    "Cyklus aktivity je každých * dní. Po skončení se provede vyúčtování. Pokud splníte požadavky, dividenda je odeslána na účet odměn. Pokud ne, váš výnos a financování platformy budou odstraněny.",
  "参与的账号需进行KYC认证，每个账户仅限一份福利。":
    "Zúčastněné účty musí být KYC ověřené. Pouze jeden bonus na účet.",
  "参与账号的KYC需要指定的国家方可参与，其他地区无权限参与，请核对活动国家与您的国家是否一致。":
    "KYC pro účast je platný pouze pro určené země. Zkontrolujte, zda vaše země odpovídá zemi aktivity.",
  "参与活动成功后，账户将临时锁定您的提现功能，当完成活动后即可解除您的提现功能。":
    "Po úspěšné účasti bude výběr dočasně zablokován do dokončení aktivity.",
  "请遵守平台活动规则，若发现作弊、利用系统漏洞进行获利，平台将会长期冻结您的账户下所有资金。":
    "Dodržujte pravidla aktivity. V případě podvádění nebo zneužívání systémových chyb budou všechny prostředky na vašem účtu trvale zmrazeny.",
  平台出资: "Financování platformy",
  平台出资收回: "Financování platformy odvoláno",
  投资大师奖励: "Odměna Mistr investor",
  请下载APP添加收款方式: "Stáhněte si aplikaci pro přidání způsobu přijetí",
  请下载APP进行身份验证: "Stáhněte si aplikaci pro provedení ověření identity",
  请下载APP参与: "Stáhněte si aplikaci pro účast",
  技术指标: "Technické indikátory",
  主图: "Hlavní graf",
  副图: "Vedlejší graf",
  新注册人数: "Nové registrace",
  老用户存款人数: "Stávající uživatelé, kteří vkládají",
  存款人数: "Počet vkladů",
  取款人数: "Počet výběrů",
  投注人数: "Počet sázek",
  "除印度尼西亚、印度、孟加拉国，且未参与过的用户。":
    "S výjimkou uživatelů z Indonésie, Indie, Bangladéše, kteří se ještě nezúčastnili.",
  市场动态: "Dynamika trhu",
  外汇合约: "Forex futures",
  盈亏比: "Poměr zisku/ztráty",
  委托价: "Cena příkazu",
  可用余额: "Dostupný zůstatek",
  持仓额: "Hodnota pozice",
  强平价: "Liquidační cena",
  修改: "Změnit",
  修改价位: "Změnit cenu",
  外汇: "Forex",
  外汇账户: "Forex účet",
  我的交易: "Moje transakce",
  未设置: "Nenastaveno",
  超出最大可设数值: "Překračuje maximální nastavitelnou hodnotu",
  超出最小可设数值: "Pod minimální nastavitelnou hodnotou",
  止盈超出最小可设数值: "Take-profit pod minimální nastavitelnou hodnotou",
  止损超出最大可设数值: "Stop-loss překračuje maximální nastavitelnou hodnotu",
  止盈超出最大可设数值:
    "Take-profit překračuje maximální nastavitelnou hodnotu",
  止损超出最小可设数值: "Stop-loss pod minimální nastavitelnou hodnotou",
  挖矿: "Těžba",
  交易账户: "Obchodní účet",
  买涨: "Koupit (Long)",
  买跌: "Prodat (Short)",
  请输入正确的银行卡信息: "Zadejte správné údaje o bankovní kartě",
  联系在线客服: "Kontaktujte živou zákaznickou podporu",
  法币交易请联系在线客服:
    "Kontaktujte zákaznickou podporu pro obchodování s fiat měnami",
  提交订单: "Odeslat objednávku",
  "支付过程如有疑问,请联系在线客服":
    "Kontaktujte zákaznickou podporu, pokud máte dotazy k platebnímu procesu",
  彩金赠送: "Přidělení bonusu",
  在线客服: "Živý chat",
  最少投资: "Minimální investice",
  "提交时间:": "Čas odeslání:",
  提现拒绝: "Výběr zamítnut",
  认证拒绝: "Ověření zamítnuto",
  认证通过: "Ověření schváleno",
  请输入正确的交易额度: "Zadejte platnou částku obchodu",
  最大下注金额: "Maximální sázka",
  手机号: "Telefonní číslo",
  邮箱注册: "Registrace e-mailem",
  手机号注册: "Registrace telefonním číslem",
  查询: "Dotaz",
  手机号登录: "Přihlásit se telefonním číslem",
  邮箱登录: "Přihlásit se e-mailem",
  请输入数量: "Zadejte množství",
  可用数量: "Dostupné množství",
  钱包登录: "Přihlásit se peněženkou",
  请输入正确的邀请码: "Zadejte platný pozvánkový kód",
  "请输入邀请码(必填)": "Zadejte pozvánkový kód (povinné)",
  输入正确的金额: "Zadejte platnou částku",
  法币充值: "Vklad fiat",
  卢比充值: "Vklad indických rupií",
  请输入法币: "Zadejte fiat částku",
  请输入IFSC: "Zadejte kód IFSC",
  "银行编码(选填)": "Kód banky (volitelné)",
  请输入银行编码: "Zadejte kód banky",
  请输入大于8位数的密码: "Zadejte heslo delší než 8 znaků",
  添加成功: "Přidáno",
  "60秒": "60 sekund",
  "180秒": "180 sekund",
  "300秒": "300 sekund",
  "2次密码不一致": "Hesla se neshodují",
  输入提币数量: "Zadejte množství výběru",
  图片格式不正确: "Neplatný formát obrázku",
  图片大于20M: "Obrázek je větší než 20 MB",
  请设置委托价格: "Nastavte cenu příkazu",
  输入资金密码: "Zadejte heslo aktiv",
  验证码错误: "Neplatný ověřovací kód",
  充值拒绝: "Vklad zamítnut",
  请输入SSN: "Zadejte SSN",
  结算完成: "Vypořádání dokončeno",
  继续下单: "Pokračovat v objednávání",
  限价: "Limitní příkaz",
  买入价格: "Nákupní cena",
  买入量: "Množství k nákupu",
  卖出价格: "Prodejní cena",
  卖出量: "Množství k prodeji",
  买入: "Koupit",
  卖出: "Prodat",
  订单创建成功: "Objednávka vytvořena",
  币币买入支出: "Výdaj na spotový nákup",
  币币买入支出退还: "Vrácení výdaje na spotový nákup",
  币币买入获得: "Získané z spotového nákupu",
  币币卖出支出: "Výdaj na spotový prodej",
  币币卖出支出退还: "Vrácení výdaje na spotový prodej",
  币币卖出获得: "Získané z spotového prodeje",
  币币交易手续费: "Poplatek za spotovou transakci",
  请输入限价: "Zadejte limitní cenu",
  成交: "Provedeno",
  等待成交: "Čeká na provedení",
  交易完成: "Transakce dokončena",
  被取消: "Zrušeno",
  交易时间: "Čas transakce",
  法币交易: "Fiat transakce",
  法币出售: "Fiat prodej",

  两次密码不一致: "Hesla se neshodují",
  再次输入账户密码: "Zadejte znovu heslo účtu",

  美国: "Spojené státy",
  韩国: "Jižní Korea",
  阿尔巴尼亚: "Albánie",
  津巴布韦: "Zimbabwe",
  赞比亚: "Zambie",
  也门: "Jemen",
  美属维尔京群岛: "Americké Panenské ostrovy",
  英属处女群岛: "Britské Panenské ostrovy",
  越南: "Vietnam",
  委内瑞拉: "Venezuela",
  瓦努阿图: "Vanuatu",
  乌兹别克斯坦: "Uzbekistán",
  乌拉圭: "Uruguay",
  英国: "Spojené království",
  阿拉伯联合酋长国: "Spojené arabské emiráty",
  乌克兰: "Ukrajina",
  乌干达: "Uganda",
  特克斯和凯科斯群岛: "Turks a Caicos",
  土库曼斯坦: "Turkmenistán",
  土耳其: "Turecko",
  突尼斯: "Tunisko",
  特立尼达和多巴哥: "Trinidad a Tobago",
  汤加: "Tonga",
  多哥: "Togo",
  东帝汶: "Východní Timor",
  泰国: "Thajsko",
  坦桑尼亚: "Tanzanie",
  塔吉克斯坦: "Tádžikistán",
  中国台湾: "Tchaj-wan",
  叙利亚: "Sýrie",
  瑞士: "Švýcarsko",
  瑞典: "Švédsko",
  斯威士兰: "Svazijsko",
  苏里南: "Surinam",
  苏丹: "Súdán",
  斯里兰卡: "Srí Lanka",
  西班牙: "Španělsko",
  南非: "Jižní Afrika",
  索马里: "Somálsko",
  所罗门群岛: "Šalamounovy ostrovy",
  斯洛文尼亚: "Slovinsko",
  斯洛伐克: "Slovensko",
  "圣马丁岛（荷兰部分）": "Svatý Martin (nizozemská část)",
  新加坡: "Singapur",
  塞拉利昂: "Sierra Leone",
  塞舌尔: "Seychely",
  塞尔维亚: "Srbsko",
  塞内加尔: "Senegal",
  沙特阿拉伯: "Saúdská Arábie",
  圣多美和普林西比: "Svatý Tomáš a Princův ostrov",
  圣马力诺: "San Marino",
  萨摩亚: "Samoa",
  圣克里斯托弗和尼维斯: "Svatý Kryštof a Nevis",
  圣文森特和格林纳丁斯: "Svatý Vincenc a Grenadiny",
  圣彼埃尔和密克隆岛: "Saint-Pierre a Miquelon",
  圣露西亚: "Svatá Lucie",
  圣基茨和尼维斯: "Svatý Kryštof a Nevis",
  卢旺达: "Rwanda",
  俄罗斯: "Rusko",
  罗马尼亚: "Rumunsko",
  留尼汪: "Réunion",
  刚果共和国: "Republika Kongo",
  卡塔尔: "Katar",
  波多黎各: "Portoriko",
  葡萄牙: "Portugalsko",
  波兰: "Polsko",
  菲律宾: "Filipíny",
  秘鲁: "Peru",
  巴拉圭: "Paraguay",
  巴布亚新几内亚: "Papua Nová Guinea",
  巴拿马: "Panama",
  巴勒斯坦: "Palestina",
  帕劳: "Palau",
  巴基斯坦: "Pákistán",
  阿曼: "Omán",
  挪威: "Norsko",
  尼日利亚: "Nigérie",
  尼日尔: "Niger",
  尼加拉瓜: "Nikaragua",
  新西兰: "Nový Zéland",
  新喀里多尼亚: "Nová Kaledonie",
  荷属安德列斯群岛: "Nizozemské Antily",
  荷兰: "Nizozemsko",
  尼泊尔: "Nepál",
  纳米比亚: "Namibie",
  缅甸: "Myanmar",
  莫桑比克: "Mosambik",
  摩洛哥: "Maroko",
  蒙特塞拉特岛: "Montserrat",
  黑山: "Černá Hora",
  蒙古: "Mongolsko",
  摩纳哥: "Monako",
  摩尔多瓦: "Moldavsko",
  墨西哥: "Mexiko",
  马约特: "Mayotte",
  毛里求斯: "Mauricius",
  毛里塔尼亚: "Mauritánie",
  马里亚纳群岛: "Mariány",
  马提尼克: "Martinik",
  马耳他: "Malta",
  马里: "Mali",
  马尔代夫: "Maledivy",
  马来西亚: "Malajsie",
  马拉维: "Malawi",
  马达加斯加: "Madagaskar",
  马其顿: "Severní Makedonie",
  中国澳门: "Macao",
  卢森堡: "Lucembursko",
  立陶宛: "Litva",
  列支敦士登: "Lichtenštejnsko",
  利比亚: "Libye",
  利比里亚: "Libérie",
  莱索托: "Lesotho",
  黎巴嫩: "Libanon",
  拉脱维亚: "Lotyšsko",
  老挝: "Laos",
  吉尔吉斯斯坦: "Kyrgyzstán",
  科威特: "Kuvajt",
  基里巴斯: "Kiribati",
  肯尼亚: "Keňa",
  哈萨克斯坦: "Kazachstán",
  约旦: "Jordánsko",
  日本: "Japonsko",
  牙买加: "Jamajka",
  象牙海岸: "Pobřeží slonoviny",
  意大利: "Itálie",
  以色列: "Izrael",
  爱尔兰: "Irsko",
  伊拉克: "Irák",
  伊朗: "Írán",
  印度尼西亚: "Indonésie",
  印度: "Indie",
  冰岛: "Island",
  匈牙利: "Maďarsko",
  中国香港: "Hongkong",
  洪都拉斯: "Honduras",
  海地: "Haiti",
  圭亚那: "Guyana",
  几内亚比绍共和国: "Guinea-Bissau",
  几内亚: "Guinea",
  危地马拉: "Guatemala",
  关岛: "Guam",
  瓜德罗普岛: "Guadeloupe",
  格林纳达: "Grenada",
  格陵兰岛: "Grónsko",
  希腊: "Řecko",
  直布罗陀: "Gibraltar",
  加纳: "Ghana",
  德国: "Německo",
  格鲁吉亚: "Gruzie",
  冈比亚: "Gambie",
  加蓬: "Gabon",
  法属波利尼西亚: "Francouzská Polynésie",
  法属圭亚那: "Francouzská Guyana",
  法国: "Francie",
  芬兰: "Finsko",
  斐济: "Fidži",
  法罗群岛: "Faerské ostrovy",
  埃塞俄比亚: "Etiopie",
  爱沙尼亚: "Estonsko",
  厄立特里亚: "Eritrea",
  赤道几内亚: "Rovníková Guinea",
  萨尔瓦多: "Salvador",
  埃及: "Egypt",
  厄瓜多尔: "Ekvádor",
  多米尼加共和国: "Dominikánská republika",
  多米尼加: "Dominika",
  吉布提: "Džibutsko",
  丹麦: "Dánsko",
  捷克: "Česko",
  塞浦路斯: "Kypr",
  库拉索: "Curaçao",
  古巴: "Kuba",
  克罗地亚: "Chorvatsko",
  哥斯达黎加: "Kostarika",
  科特迪瓦: "Pobřeží slonoviny",
  库克群岛: "Cookovy ostrovy",
  科摩罗: "Komory",
  哥伦比亚: "Kolumbie",
  智利: "Chile",
  乍得: "Čad",
  中非共和国: "Středoafrická republika",
  佛得角: "Kapverdy",
  开曼群岛: "Kajmanské ostrovy",
  开普: "Cape",
  加拿大: "Kanada",
  喀麦隆: "Kamerun",
  柬埔寨: "Kambodža",
  布隆迪: "Burundi",
  布基纳法索: "Burkina Faso",
  保加利亚: "Bulharsko",
  文莱: "Brunej",
  巴西: "Brazílie",
  博茨瓦纳: "Botswana",
  波斯尼亚和黑塞哥维那: "Bosna a Hercegovina",
  玻利维亚: "Bolívie",
  不丹: "Bhútán",
  百慕大群岛: "Bermudy",
  贝宁: "Benin",
  伯利兹: "Belize",
  比利时: "Belgie",
  白俄罗斯: "Bělorusko",
  巴巴多斯: "Barbados",
  孟加拉国: "Bangladéš",
  巴林: "Bahrajn",
  巴哈马: "Bahamy",
  阿塞拜疆: "Ázerbájdžán",
  奥地利: "Rakousko",
  澳大利亚: "Austrálie",
  阿鲁巴: "Aruba",
  亚美尼亚: "Arménie",
  阿根廷: "Argentina",
  安提瓜和巴布达: "Antigua a Barbuda",
  安圭拉: "Anguilla",
  安哥拉: "Angola",
  安道尔: "Andorra",
  美属萨摩亚: "Americká Samoa",
  阿尔及利亚: "Alžírsko",
  中国: "Čína",
  余额不足: "Nedostatečný zůstatek",
  最低购买: "Minimální nákup",
  最高购买: "Maximální nákup",
  下单成功: "Objednávka odeslána",
  平仓成功: "Pozice uzavřena",
  请输入正确的平仓数量: "Zadejte platné množství k uzavření",
  加仓成功: "Pozice zvýšena",
  请输入正确的加仓金额: "Zadejte platnou částku pro zvýšení pozice",
  收藏成功: "Přidáno do oblíbených",
  取消收藏成功: "Odebráno z oblíbených",
  加密币永续: "Perpetual kryptoměny",
  外汇永续: "Perpetual Forex",
  期权账户: "Účet opcí",
  快捷卖币: "Rychlý prodej kryptoměny",

  托管资金: "Spravované prostředky",
  托管中: "Ve správě",
  预计日收益: "Odhadovaný denní výnos",
  累计收益: "Celkový výnos",
  周期: "Doba trvání",
  日收益: "Denní výnos",
  限额: "Limit",
  立即托管: "Zahájit správu nyní",
  "已鎖定 請聯繫客服": "Zamčeno. Kontaktujte zákaznickou podporu.",
  产品列表: "Seznam produktů",
  规则: "Pravidla",
  创建订单: "Vytvořit objednávku",
  产品名称: "Název produktu",
  托管周期: "Období správy",
  等级限制: "Omezení úrovně",
  托管金额: "Spravovaná částka",
  限额: "Limit",
  余额: "Zůstatek",
  购买日: "Datum nákupu",
  起息日: "Datum počátku úročení",
  派息时间: "Čas výplaty úroků",
  每天: "Denně",
  计息结束日: "Datum ukončení úročení",
  每日收益: "Denní výnos",
  预计收益: "Odhadovaný výnos",
  "收益将自动发送至您的余额账户;":
    "Výnos bude automaticky odeslán na zůstatek vašeho účtu;",
  "您的资金没有任何风险;": "Vaše prostředky nejsou vystaveny žádnému riziku;",
  "365*24小时不断地工作;": "Pracuje 24/7, 365 dní v roce;",
  托管中: "Ve správě",
  结束: "Ukončeno",
  今日收益: "Dnešní výnos",
  剩余周期: "Zbývající doba",
  进行中: "Aktivní",
  已发放: "Vyplaceno",
  信誉分: "Body reputace",

  复制成功: "Zkopírováno úspěšně",
  VIP权益: "VIP výhody",
  旧密码: "Staré heslo",
  请输入旧密码: "Zadejte staré heslo",
  "忘记旧密码请联系客服重置。":
    "Pokud jste zapomněli své staré heslo, kontaktujte zákaznickou podporu pro jeho resetování.",
  去升级: "Upgradovat",
  描述: "Popis",
  实际存款金额: "Skutečná částka vkladu",
  升级礼金: "Bonus za upgrade",
  隔夜利息: "Přes noc úrok (swap)",
  自动结算: "Automatické vypořádání",
  等级规则: "Pravidla úrovní",
  "WEB3.0币持有数据收益": "Výnos z dat o držení mincí WEB3.0",
  总生产: "Celková produkce",
  有效节点: "Aktivní uzly",
  参与人: "Účastníci",
  用户收益: "Výnos uživatele",
  "流动性WEB3.0输出": "Výstup likvidity WEB3.0",
  总资产: "Celková aktiva",

  ETHAI持有数据收益: "Výnos z dat držení ETHAI",
  AI量化流动性: "AI kvantitativní likvidita",
  现货买入手续费: "Poplatek za nákup spot",
  现货支出: "Spot výdaj",
  现货资金费率: "Spot sazba financování",
  现货卖出手续费: "Poplatek za prodej spot",
  现货收入: "Spot příjem",
  外汇合约支出: "Výdaj na devizový kontrakt",
  外汇合约买入手续费: "Poplatek za nákup devizového kontraktu",
  外汇合约资金费率: "Sazba financování devizového kontraktu",
  外汇合约卖出手续费: "Poplatek za prodej devizového kontraktu",
  外汇合约收入: "Příjem z devizového kontraktu",
  理财购买: "Nákup investičního produktu",
  VIP理财日收益: "Denní výnos VIP investičního produktu",
  VIP理财隔夜利息: "Přes noc úrok VIP investičního produktu",
  VIP本金返还: "VIP vrácení jistiny",
  VIP彩金发放: "VIP výplata bonusu",
  VIP彩金抵扣: "VIP odečet bonusu",
  隔夜利息: "Přes noc úrok",
  设置资产密码: "Nastavit heslo aktiv",

  锁仓挖矿: "Uzamčená těžba",
  一站式理财服务: "Finanční služby na jednom místě",
  产品: "Produkty",
  客服中心: "Zákaznické centrum",
  贷款: "Půjčky",
  挖矿赚不停: "Neustálý výdělek z těžby",
  "锁仓挖矿是通过将USDT (USD:1USDT=1USD) 托管给平台超算力矿机，在平台矿池中进行挖矿收益。":
    "Uzamčená těžba spočívá v uložení USDT (USD:1USDT=1USD) do vysoce výkonných těžebních zařízení platformy za účelem získávání výnosů v těžebním poolu platformy.",
  产品优势: "Výhody produktu",
  随存随取: "Vklad a výběr kdykoliv",
  锁仓周期: "Doba uzamčení",
  每日下发: "Denní výplaty",
  随机空投: "Náhodné airdropy",
  "100%资金安全保障": "100% záruka bezpečnosti prostředků",
  "100%节假日收益不间断": "100% nepřetržitý výnos i o svátcích",
  成功锁仓后当天产出: "Výnosy začínají v den úspěšného uzamčení",
  关于违约金: "O smluvní pokutě",
  "若您希望转出未到期的本金,则会产生违约金,违约金=违约结算比例*剩余天数*锁仓金额.":
    "Pokud chcete vybrat kapitál před splatností, bude účtována smluvní pokuta. Pokuta = sazba pokuty × zbývající dny × uzamčená částka.",
  "举例:此锁仓挖矿的违约结算比例为5%,剩余3天到期,锁仓金额为10000U《USDT/USD》,则违约金=5%*3*10000=1500U,实际退回本金为15000U-1500U":
    "Příklad: sazba pokuty u tohoto produktu je 5 %, zbývají 3 dny do splatnosti a uzamčená částka je 10000U (USDT/USD). Pokuta = 5%×3×10000=1500U, skutečně vrácený kapitál je 15000U-1500U.",
  收益计算: "Výpočet výnosu",
  "平台有多种锁仓挖矿理财产品供使用者选择,收益计算如下,举例:":
    "Platforma nabízí různé finanční produkty uzamčené těžby. Výpočet výnosu je následující, například:",
  "会员在平台锁仓10000U(USDT,USD),如选择了周期为7天,日产出为锁仓金额的0.7%~1.8%的理财产品,则每天产出如下":
    "Pokud uživatel uzamkne 10000U (USDT, USD) a zvolí 7denní produkt s denním výnosem 0,7%~1,8 % z uzamčené částky, denní výnos je následující:",
  "最低:10000Ux0.7%=70U;": "Minimum: 10000U×0,7%=70U;",
  "最高:10000Ux1.8%=180U;": "Maximum: 10000U×1,8%=180U;",
  "即7天后可获得490U~1260U的收益,收益每日下发,锁仓本金到期后,自动转入您的资金账户.":
    "Po 7 dnech lze získat výnos 490U~1260U. Výnosy jsou vypláceny denně a po splatnosti je kapitál automaticky převeden na váš účet.",
  正在托管的资金: "Spravované prostředky",
  签到: "Přihlášení",
  锁仓订单: "Uzamčené objednávky",
  预计今日收益: "Odhad dnešního výnosu",
  累计收益: "Kumulovaný výnos",
  托管中的订单: "Objednávky ve správě",
  单笔最少: "Minimální částka na objednávku",
  单笔最多: "Maximální částka na objednávku",
  日收益率: "Denní výnos",
  说明: "Popis",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出<br>3.当天的收益会统一在次日GMT+8时间00:00-00:10内派发.":
    "1. Statistiky jsou založeny na čase GMT+8<br>2. Denní výnosy jsou počítány ze všech vypořádaných objednávek mezi 00:00–23:59 GMT+8 (místní čas 00:00–23:59)<br>3. Výnosy jsou vypláceny následující den mezi 00:00–00:10 GMT+8.",
  知道了: "Rozumím",
  锁仓: "Uzamknout",
  派息时间: "Čas výplaty",
  每日: "Denně",
  托管资金: "Spravované prostředky",
  到期返回: "Vrácení při splatnosti",
  提前赎回: "Předčasné vyplacení",
  预计收益: "Odhadovaný výnos",
  认购: "Předplatit",
  热门: "Populární",
  数字货币: "Kryptoměny",
  贵金属: "Drahé kovy",
  大宗商品: "Komodity",
  持仓明细: "Detail pozic",
  历史明细: "Historie",
  当前价: "Aktuální cena",
  "↑买涨": "↑ Nákup na růst",
  "↓买跌": "↓ Nákup na pokles",
  显示全部: "Zobrazit vše",
  买入金额: "Částka nákupu",
  方向: "Směr",
  收益: "Zisk",
  预期收益: "Očekávaný zisk",
  估用保证金: "Odhadovaná marže",
  确认下单: "Potvrdit objednávku",
  锁定: "Uzamčeno",
  账户总资产: "Celková aktiva účtu",
  明细: "Detaily",
  今日收益: "Dnešní výnos",
  仓位保证金: "Marže pozice",
  持有仓位: "Držené pozice",
  "锁定金额=所有锁仓挖矿中未完成订单的金额总和":
    "Uzamčená částka = součet všech neukončených objednávek uzamčené těžby",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出":
    "1. Statistiky jsou založeny na čase GMT+8<br>2. Denní výnosy jsou počítány ze všech vypořádaných objednávek mezi 00:00–23:59 GMT+8 (místní čas 00:00–23:59)",
  充值方式: "Způsob vkladu",
  银行汇款: "Bankovní převod",
  "银行汇款请联系客服进行操作!":
    "Pro bankovní převod kontaktujte zákaznickou podporu!",
  提款方式: "Způsob výběru",
  "银行提款请联系客服进行操作!":
    "Pro bankovní výběr kontaktujte zákaznickou podporu!",
  资金明细: "Detail prostředků",
  提现记录: "Historie výběrů",
  拒绝: "Odmítnuto",
  通过: "Schváleno",
  拒绝原因: "Důvod zamítnutí",

  消息公告: "Oznámení",
  订单: "Objednávky",
  个人中心: "Osobní centrum",
  "未到期赎回需支付一定的违约金!":
    "Při předčasném odkupu je nutné zaplatit smluvní pokutu.",

  请输入区号: "Zadejte prosím předvolbu",
  "请选择国家/地区": "Vyberte prosím zemi/oblast",

  今日开盘: "Dnešní otevření",
  昨日收盘: "Včerejší uzavření",

  实名认证即送: "Získejte ihned po ověření identity",
  立即认证: "Ověřit nyní",
  新用户礼包: "Dárkový balíček pro nové uživatele",
  完成新人任务领取: "Dokončete úkoly pro nové uživatele a získejte odměnu",
  认证: "Ověřit",
  时间周期: "Časové období",
  支付金额: "Částka platby",
  已平仓: "Uzavřeno",
  "MGBX 新用户欢迎礼包：每位用户最多可获得":
    "Uvítací balíček MGBX pro nové uživatele: každý uživatel může získat maximálně",
  我已经阅读并同意: "Přečetl(a) jsem si a souhlasím s",
  隐私政策: "Zásady ochrany osobních údajů",

  放弃奖励离开: "Opustit odměnu a odejít",
  继续注册: "Pokračovat v registraci",
  分钟: "Minuty",

  "请先勾选隐私政策!":
    "Nejprve si prosím přečtěte Zásady ochrany osobních údajů!",
  添加其他到自选: "Přidat další do seznamu sledovaných položek",
  充值最高可得: "Navýšit a získat až 30 000 USD.",

  请输入格式正确的手机号: "Zadejte prosím platné číslo mobilního telefonu.",

  收起: "Collapse",
  上传截图: "Upload screenshot",
  "*充值成功后必须上传充值截图，否则将视为无效存款。": "*After a successful recharge, you must upload the recharge screenshot; otherwise the deposit will be invalid.",
};
// 捷克



// WEBPACK FOOTER //
// ./src/lang/jk.js